import { render } from "./CbTeamInfo.vue?vue&type=template&id=0293c918&scoped=true&ts=true"
import script from "./CbTeamInfo.vue?vue&type=script&lang=ts"
export * from "./CbTeamInfo.vue?vue&type=script&lang=ts"

import "./CbTeamInfo.vue?vue&type=style&index=0&id=0293c918&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0293c918"]])

export default __exports__